import "../App.scss";

import React from "react";

import { LoadingOutlined } from "@ant-design/icons";

const Loader = () => (
  <div className="loader">
    <LoadingOutlined />
  </div>
);

export default Loader;
